"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sortable = void 0;

var _react = require("react");

var _naturalOrderby = require("natural-orderby");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function getNextDirection(previousOrderDirection) {
  if (previousOrderDirection === 'asc') {
    return 'desc';
  }

  if (previousOrderDirection === 'desc') {
    return '';
  }

  return 'asc';
}

var Sortable =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Sortable, _PureComponent);

  var _super = _createSuper(Sortable);

  function Sortable(props) {
    var _this;

    _classCallCheck(this, Sortable);

    _this = _super.call(this, props);
    _this.getColumnNamesAndOrderBy = _this.getColumnNamesAndOrderBy.bind(_assertThisInitialized(_this));
    _this.onOrderBy = _this.onOrderBy.bind(_assertThisInitialized(_this));
    _this.orderRows = _this.orderRows.bind(_assertThisInitialized(_this));
    _this.state = {
      columnName: props.defaultSortColumn ? props.defaultSortColumn : '',
      orderDirection: props.defaultSortOrder ? props.defaultSortOrder : '',
      orderResults: props.doOrderByOnInitialization
    };
    return _this;
  }

  _createClass(Sortable, [{
    key: "onOrderBy",
    value: function onOrderBy(columnName) {
      var _this2 = this;

      return function (event) {
        if (event.target.classList.contains('DragHandle')) {
          return;
        }

        if (columnName !== _this2.state.columnName) {
          _this2.setState({
            columnName: columnName,
            orderDirection: 'asc',
            orderResults: true
          });

          return;
        }

        _this2.setState(function (prevState) {
          return {
            orderDirection: getNextDirection(prevState.orderDirection),
            orderResults: true
          };
        });
      };
    }
  }, {
    key: "getColumnNamesAndOrderBy",
    value: function getColumnNamesAndOrderBy() {
      return _defineProperty({}, this.state.columnName, this.state.orderDirection);
    }
  }, {
    key: "orderRows",
    value: function orderRows() {
      var _this3 = this;

      if (!this.state.orderResults) {
        return this.props.rows;
      }

      if (!this.props.iterateOrderByUsing) {
        return (0, _naturalOrderby.orderBy)(this.props.rows, [this.state.columnName], [this.state.orderDirection]);
      }

      return (0, _naturalOrderby.orderBy)(this.props.rows, function (row) {
        return _this3.props.iterateOrderByUsing(row[_this3.state.columnName]);
      }, [this.state.orderDirection]);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        rows: this.orderRows(),
        onOrderBy: this.onOrderBy,
        columnNamesAndOrderBy: this.getColumnNamesAndOrderBy()
      });
    }
  }]);

  return Sortable;
}(_react.PureComponent);

exports.Sortable = Sortable;
Sortable.propTypes = {
  children: _propTypes["default"].func.isRequired,
  defaultSortColumn: _propTypes["default"].string,
  defaultSortOrder: _propTypes["default"].string,
  doOrderByOnInitialization: _propTypes["default"].bool,
  iterateOrderByUsing: _propTypes["default"].func,
  rows: _propTypes["default"].instanceOf(Array)
};
Sortable.defaultProps = {
  defaultSortColumn: null,
  defaultSortOrder: null,
  doOrderByOnInitialization: true,
  iterateOrderByUsing: null,
  rows: []
};